module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [(_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.componentType))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.componentType),
      expression: "value.componentType"
    }],
    attrs: {
      "disabled": !_vm.createMode
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value.componentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("–––")]), _vm._v(" "), _vm._l((_vm.componentTypes), function(type) {
    return _c('option', {
      key: type.key,
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(_vm.trads.compotentTypeNames[type.key]))])
  })], 2), _vm._v(" "), _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.name))]), _vm._v(" "), _c('TranslationInput', {
    model: {
      value: (_vm.value.name),
      callback: function($$v) {
        _vm.value.name = $$v
      },
      expression: "value.name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.shortName))]), _vm._v(" "), _c('TranslationInput', {
    model: {
      value: (_vm.value.nickname),
      callback: function($$v) {
        _vm.value.nickname = $$v
      },
      expression: "value.nickname"
    }
  }), _vm._v(" "), (!_vm.isProduct && _vm.hasAccessApplication('plano_builder')) ? _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.systemType))]) : _vm._e(), _vm._v(" "), (!_vm.isProduct && _vm.hasAccessApplication('plano_builder')) ? _c('CheckboxGroup', {
    attrs: {
      "id": "system-types",
      "name": "system-type",
      "options": _vm.systemTypes
    },
    model: {
      value: (_vm.value.selectedSystemTypes),
      callback: function($$v) {
        _vm.value.selectedSystemTypes = $$v
      },
      expression: "value.selectedSystemTypes"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isProduct && _vm.hasAccessApplication('plano_builder')) ? _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.availableOn.label))]) : _vm._e(), _vm._v(" "), (!_vm.isProduct && _vm.hasAccessApplication('plano_builder')) ? _c('CheckboxGroup', {
    attrs: {
      "id": "available-on",
      "options": _vm.availableOn
    },
    model: {
      value: (_vm.value.selectedAvailableOn),
      callback: function($$v) {
        _vm.value.selectedAvailableOn = $$v
      },
      expression: "value.selectedAvailableOn"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.design))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.standDesignId),
      expression: "value.standDesignId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value.standDesignId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("–––")]), _vm._v(" "), _vm._l((_vm.standDesigns), function(design) {
    return _c('option', {
      key: design.id,
      domProps: {
        "value": design.id
      }
    }, [_vm._v(_vm._s(design.name))])
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d722338","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/form-head.vue
// module id = 3134
// module chunks = 0